import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './Header.css';

const PREVIOUS_PAGE = {
  '/rules': '/',
  '/round-1': '/rules',
  '/round-2': '/round-1',
  '/round-3': '/round-2',
};

export default function Header() {
  const { user } = useAuth();
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const previousPage =
    pathname === '/thankyou' ? null : PREVIOUS_PAGE[pathname] || null;
  const logoUrl = user?.companyLogoUrl || process.env.REACT_APP_EM_LOGO;
  const backUrl = user?.backButtonRedirect || process.env.REACT_APP_BASE_URL || '/';

  if (!logoUrl) return null;

  return (
    <header className="upperaction">
      <a href={process.env.REACT_APP_BASE_URL || '/'}>
        <img src={logoUrl} className="logo-holder" alt="Company Logo" />
      </a>
      <div className="back-holder">
        {previousPage ? (
          <button type="button" className="back-default" onClick={() => navigate(previousPage)}>
            Back
          </button>
        ) : (
          <a href={backUrl}>
            <button type="button" className="back-default">Back</button>
          </a>
        )}
      </div>
    </header>
  );
}
